import { NgModule } from '@angular/core';
import { ObjectTypePipe } from './object-type.pipe';

@NgModule({
  providers: [ObjectTypePipe],
  declarations: [ObjectTypePipe],
  exports: [ObjectTypePipe],
})
export class ObjectTypePipeModule {}
